import {SubmitForm} from './submitForm';

/**
 * Base class for forms on public pages (login, sign-up, account recovery, password reset and
 * registration). These must work while a guest session is still stored in the tab, so the
 * guest-admin block of {@link SubmitForm#onSubmit} does not apply.
 */
export abstract class PublicSubmitForm extends SubmitForm
{
    protected override allowsGuestUsers(): boolean
    {
        return true;
    }
}
